// extracted by mini-css-extract-plugin
export default {"tooltip":"preferredCompaniesTooltip_tooltip__zOxEv","icon":"preferredCompaniesTooltip_icon__AQgcj"};